import React, { Component } from 'react';
import AppStore from '../../stores/app-store.js'
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';

import '../../grid.css';
import './GuardaHistoria.css';

import { deepOrange500 } from 'material-ui/styles/colors';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

const muiTheme = getMuiTheme({
    palette: {
        accent1Color: deepOrange500,
    },
});

class GuardaHistoria extends Component {
    constructor() {
        super();
        this.guardar = this.guardar.bind(this);
        this.state = {
            nomeHistoria: '',
            legendas: AppStore.legendas,
        }
        this.textoHistoria = '';
        this.guardados = [];
        this.onChangeLingua = this.onChangeLingua.bind(this);
    }

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    }

    componentWillMount() {
        let tmp = localStorage.getItem("vdv_guardados");
        if (tmp) {
            this.guardados = tmp.split(",");
        }
        this.textoHistoria = AppStore.getSequenciaHistorias();
        AppStore.addChangeLinguaListener(this.onChangeLingua);
    }

    componentWillUnmount() {
        AppStore.removeChangeLinguaListener(this.onChangeLingua);
    }


    onChangeLingua() {
        this.setState({
            legendas: AppStore.legendas,
        })
    }

    handleInputChange = (event) => {
        this.setState({
            nomeHistoria: event.target.value,
        });
    };

    guardar() {
        let len = this.state.nomeHistoria.length;
        if (len > 0) {
            this.guardados.push(this.state.nomeHistoria);
            let tmp = this.guardados.toString();
            localStorage.setItem("vdv_guardados", tmp);
            localStorage.setItem(this.state.nomeHistoria, this.textoHistoria);
        }
        this.context.router.push('/capa');
    }

    render() {
        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div className="GuardaHistoria">
                    <TextField
                        style={{ maxWidth: '90%', fontFamily: 'OpenSans', color: 'white' }}
                        textareaStyle={{ color: 'white' }}
                        inputStyle={{ color: 'white' }}
                        hintStyle={{ color: 'white' }}
                        hintText={this.state.nomeHistoria}
                        floatingLabelText={this.state.legendas.nomeHistoria}
                        floatingLabelStyle={{ color: 'white' }}
                        multiLine={false}
                        rows={1}
                        rowsMax={1}
                        value={this.state.nomeHistoria}
                        onChange={this.handleInputChange}
                    />
                    <RaisedButton label={this.state.legendas.guardar} primary={true} onTouchTap={this.guardar} />
                </div>
            </MuiThemeProvider>
        );
    }

}
export default GuardaHistoria;


// WEBPACK FOOTER //
// ./src/componentes/guardahistoria/GuardaHistoria.js